import React, { useState } from "react";
import MaterialTable from 'material-table';

export default function DataTable(props) {

    const [data, setData] = useState(props.registro);

    const columns = [
        {
            title: 'Nro C.I',
            field: 'cedula',
            width: 150,
        },
        {
            title: 'Nombres',
            field: 'nombres',
            width: 270,
        },
        {
            title: 'Tipo',
            field: 'tipo_certificado',
            width: 200,
        },
        {
            title: 'Fecha Emisión',
            field: 'fecha_inicial',
            width: 200,
        },
        {
            title: 'Fecha Vencimiento',
            field: 'fecha_final',
            width: 200,
        },
    ]

    return (
        <MaterialTable
            columns={columns}
            data={data}
            title="Lista de Certificados"
            options={{
                //grouping: true,
                //filtering: true,
                headerStyle: {
                    color: "#000",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                    backgroundColor: '#808080',
                    fontSize: 20
                },
                padding: 'dense',
                paging: true,
                pageSizeOptions: [10, 20, 30, 50, 100],
                pageSize: 10
            }}
            localization={{
                pagination: {
                    labelDisplayedRows: '{from}-{to} de {count} registros',
                    labelRowsSelect: 'filas',
                    firstTooltip: 'Primera página',
                    previousTooltip: 'Página anterior',
                    nextTooltip: 'Próxima página',
                    lastTooltip: 'Última página'
                },
                header: {
                    actions: 'Acciones'
                },
                body: {
                    emptyDataSourceMessage: 'No se encontraron resultados',
                    filterRow: {
                        filterTooltip: 'Buscar'
                    }
                },
                grouping: {
                    placeholder: 'Arrastra los encabezados aquí para agruparlos por',
                    groupedBy: 'Agrupado por:'
                },
                toolbar: {
                    searchTooltip: 'Buscar',
                    searchPlaceholder: 'Buscar'
                }
            }}
        />
    );
}